import useAuth from 'src/hooks/useAuth';

const useIsAutoInviteEnabled = () => {
    const { user } = useAuth();
    return user?.company?.autoInvite;
};

export default useIsAutoInviteEnabled;
